import React from "react";
import Mainmenu from "./Mainmenu";
import Topbar from "./Topbar";
import { Outlet } from "react-router-dom";

export default function Layoutinner() {
  return (
    <div id="wrapper">
      <Mainmenu />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Topbar />
          <div>
            <Outlet />
          </div>
        </div>
        <footer class="sticky-footer bg-white mt-5">
            <div class="container my-auto mt-5">
              <div class="copyright text-center my-auto mt-5">
                <span>Copyright Reserved © 2024</span>
              </div>
            </div>
          </footer>
      </div>
    </div>
  );
}
